module.exports = __webpack_public_path__ + "static/banner-blocklynx-a3deca03218218c92a317ac465011526.png";